<section class="m-0">
  <ness-message></ness-message>
  <p-table [value]="firearmTrace" responsiveLayout="scroll" tableStyleClass="table-striped" [scrollable]="true" [showLoader]="true" [loading]="loading">
    <ng-template pTemplate="caption">
      <div class="text-center">
        <p class="text-danger mb-2 me-md-2">Use this section to enter <span class="fw-bold">only trace</span> FTS ID.</p>
        <form [formGroup]="matchForm" novalidate class="ms-md-auto py-2 px-md-2 px-lg-4">
            <div class="form-group m-2">
                <label for="FTSID" class="required-field col-md-auto col-form-label mb-2 me-md-2 fw-bold">Trace FTS ID:</label>
                <input id="FTSID" type="text" [attr.autofocus]="true" formControlName="FTSID" class="form-control col-md mb-2 me-md-2" aria-required="true" (focus)="msgService.clear()" />
                <div class="invalid-feedback" *ngIf="matchForm.get('FTSID').invalid">
                  Please enter a valid Trace FTS ID.
                </div>
                <div class="invalid-feedback" *ngIf="matchForm.get('FirearmID').invalid">
                  There is no Firearm ID associated with this crime gun. Unable to perform ETrace match search.
                </div>
            </div>
            <div>
              <button type="button" class="btn btn-active me-auto mb-2" [disabled]="matchForm.invalid" (click)="onSearch()">Search</button>
            </div>
        </form>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col"><span class="visually-hidden">Match Category</span></th>
        <th scope="col">eTrace</th>
        <th scope="col">NESS</th>
        <th scope="col">Match</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-traceData>
      <tr>
        <th scope="row" class="fw-bold">{{ traceData.RowLabel }}</th>
        <td>{{ traceData.ETraceValue }}</td>
        <td>{{ traceData.NESSValue }}</td>
        <td [innerHtml]="traceData.Match | booleanTransformIcon" class="text-center"></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="4">No matches found.</td></tr>
    </ng-template>
  </p-table>
  <div class="my-3 d-flex justify-content-end">
    <button type="button" class="btn btn-active ms-3" [disabled]="invalidTraceData" aria-describedby="tooltip" pTooltip="Ensure the information entered is correct before confirming." tooltipStyleClass="bg-warning" tooltipPosition="top" (click)="onConfirmMatch()">Confirm</button>
    <button type="button" class="btn btn-secondary" (click)="resetTraceSearch()">Reset</button>
    <div id="tooltip" class="visually-hidden">
      Ensure the information entered is correct before confirming.
    </div>
  </div>
</section>
